controllers.controller('OpenTradeController', [
    '$scope', '$state', '$filter', '$ionicModal', '$ionicLoading', '$timeout', '$q',
    'config', 'constants', 'Utils', 'AssetService', 'API', 'UserService', 'InvestCalcService', 'LocaleService',
    'OpenTradeService', 'PnlMarginService', 'UserControl', 'CurrencyConvertService',
    function ($scope, $state, $filter, $ionicModal, $ionicLoading, $timeout, $q,
              config, Const, Utils, AssetService, API, UserService, InvestCalcService, LocaleService,
              OpenTradeService, PnlMarginService, UserControl, CurrencyConvertService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.trades = [];
        $scope.user = UserService.get();
        $scope.pnl = PnlMarginService;
        $scope.constants = Const;
        $scope.showConvertToUsd = Const["showConvertToUsd"] || false;
        var orderFilter = $state.current.data.orderFilter;
        $scope.convAssets = CurrencyConvertService.find(AssetService, $scope.user.currency, 'USD', '', 1);

        filterTrades();

        function filterTrades() {
            function getTrades() {
                if (!OpenTradeService.collection) return;

                return orderFilter ?
                    OpenTradeService.collection.getPendingTrades() :
                    OpenTradeService.collection.getTrades()
            }

            $scope.trades = getTrades();

            //recalculate total profit manually
            PnlMarginService.calcTotalNetPl();
        }

        $scope.calcMarginPercents = function () {
            if ($scope.user.activeTradingAccount) {
                return $scope.user.activeTradingAccount.margin > 0 ? ($scope.pnl.data.equity / $scope.user.activeTradingAccount.margin) * 100 : 0;
            }
        };

        $scope.marginLevel = function () {
            return {width: ($scope.pnl.data.freeMargin / $scope.pnl.data.pnl * 100) + '%'};
        };

        $scope.marginUtilization = 0;
        $scope.calcMarginUtilization = function () {
            if ($scope.user.activeTradingAccount) {
                var marginUtilization = $scope.pnl.data.equity > 0 ? ($scope.user.activeTradingAccount.margin / $scope.pnl.data.equity) * 100 : 0;
                if (marginUtilization >= 0 && marginUtilization <= 200) {
                    $scope.marginUtilization = $scope.pnl.data.equity > 0 ? ($scope.user.activeTradingAccount.margin / $scope.pnl.data.equity) * 100 : 0;
                    return $scope.marginUtilization;
                }
                $scope.marginUtilization = 999;
                return $scope.marginUtilization;
            }
        };
        $scope.getMarginUtilizationBarWidth = function () {
            if ($scope.marginUtilization === 999) {
                return 100 + '%';
            }
            var marginUtilizationBarPercentage = $scope.marginUtilization / 2;
            return marginUtilizationBarPercentage + '%';
        };

        $scope.freeMarginToUsd = function () {
            return CurrencyConvertService.doConvert($scope.convAssets, $scope.pnl.data.freeMargin, 'buy', 1);
        };
        $scope.usedFundsToUsd = function () {
            return $scope.user.activeTradingAccount ? CurrencyConvertService.doConvert($scope.convAssets, Utils.decimalRound($scope.user.activeTradingAccount.margin, $scope.user.currencyDigits), 'buy', 1) : 0;
        };
        $scope.equityToUsd = function () {
            return CurrencyConvertService.doConvert($scope.convAssets, Utils.decimalRound($scope.pnl.data.equity, $scope.user.currencyDigits), 'buy', 1);
        };

        $scope.totalProfitUsd = function () {
            return CurrencyConvertService.doConvert($scope.convAssets, Utils.decimalRound($scope.pnl.data.totalProfit, $scope.user.currencyDigits), 'buy', 1);
        };

        $scope.$watch(function () {
            return OpenTradeService.collection.length()
        }, function (newVal, oldVal) {
            if (newVal !== oldVal) filterTrades();
        });

        function clear() {
            $scope.trades = [];
            $scope.user = null;
            $scope.pnl = null;
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            var state = UserControl.getState();
            state && $state.go(state, {cache: false});

            return UserService.kycCheck();
        });

        $scope.executeTrade = function (trade) {
            $state.go('root.app.invest', {
                category: trade.asset.category,
                assetId: trade.asset.id,
                action: trade.action,
                volume: trade.lots,
                backPage: 'root.app.openTrades'
            })
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('$ionicView.unloaded', clear);
        $scope.$on('clear', clear);

    }]);
